export default {
  setCemeteryState(state, data) {
    state.details = data;
  },
  setCemeteryLoadingState(state, loading) {
    state.detailsLoading = loading;
  },
};
